import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import LinkCell from "./LinkCell";
import Utils from "../../utils/Utils";
export default class LinkReel {
    constructor(x, y, index, orientation) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 300;
        this.suspenseDuration = 600;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        /** Cells of the reel */
        this.linkCells = [];
        this.t0 = 0;
        this.preStopMs = 2200; // tempo “attivo” prima del bounce (fisso!)
        this.spinMainButtonTween = null;
        this.isButtonSpinning = false;
        this.baseSpeed = 1.9; // velocità base
        this.speedJitter = 0.08; // piccola variazione
        this.delayPerReel = 120; // ms di ritardo per indice
        this.extraDelayJitter = 50; // jitter per non farli allineare
        this.index = index;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        this.numOfExtraLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_LINK_CELLS_PER_REEL;
        this.linkCellsPosition = ResourcesDispatcher.GAME_CONSTANTS.linkCellsPosition;
        this.linkReelsPosition = ResourcesDispatcher.GAME_CONSTANTS.linkReelsPosition;
        this.lastLinkCellIndex = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL + this.numOfExtraLinkCellsPerReel - 1;
        this.container = scene.add.container(x, y);
        this.createReelMask(orientation);
        this.startDelayMs = index * this.delayPerReel + Phaser.Math.Between(0, this.extraDelayJitter);
        this.spinSpeed = this.baseSpeed + index * 0.12 + Phaser.Math.FloatBetween(-this.speedJitter, this.speedJitter);
        this.phaseOffsetPx = Math.round((index * (this.cellSize.height / ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS)) % this.cellSize.height);
        this.fixedLinkCell = new LinkCell(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, 1);
        this.animationsContainer = scene.add.container(x, y);
        this.animationsContainer.add(this.fixedLinkCell.getContainer());
        this.fixedLinkCell.getContainer().setVisible(false);
        this.frame = scene.add.image(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, ResourcesDispatcher.ATLAS.LINKREEL_FRAME.key, ResourcesDispatcher.ATLAS.LINKREEL_FRAME.frameKey).setOrigin(0.5, 0.5);
        this.frameContainer = scene.add.container(x, y);
        this.frameContainer.add(this.frame);
    }
    createReelMask(orientation) {
        return;
        // se esiste già una graphics/mask precedente la distruggiamo e rimuoviamo la mask dal container
        if (this.linkReelMask) {
            this.linkReelMask.destroy();
            this.container.clearMask(true);
            this.linkReelMask = undefined;
        }
        const visibleHeight = this.cellSize.height * this.numOfLinkCellsPerReel;
        const isPortrait = orientation;
        let xContainer = 0;
        let yContainer = 0;
        let scale = 0;
        if (isPortrait == "portrait") {
            xContainer = this.container.x + 155;
            yContainer = this.container.y + 796;
            scale = 0.85;
        }
        else {
            xContainer = this.container.x + 525;
            yContainer = this.container.y + 280;
            scale = 1;
        }
        // crea la graphics che useremo per la mask (la aggiungiamo alla scena per poterla gestire/distruggere facilmente)
        this.linkReelMask = scene.make.graphics({ x: 0, y: 0, add: false });
        this.linkReelMask.fillRect(xContainer, yContainer, this.cellSize.width, visibleHeight).setScale(scale);
        // Serve per mostrare la maschera della griglia per debuggare
        // const debugGraphics = scene.add.graphics();
        // debugGraphics.lineStyle(2, 0x000000, 1); // spessore 2px, bianco
        // this.linkCells.forEach((cell) => {
        //     const c = cell.getContainer(); // container grafico della cella
        //     const width = this.cellSize.width;
        //     const height = visibleHeight;
        //     debugGraphics.strokeRect(xContainer, yContainer, width, height).setScale(scale);
        // });
        // assegna la GeometryMask basata sulla graphics appena creata
        this.container.setMask(new Phaser.Display.Masks.GeometryMask(scene, this.linkReelMask));
    }
    setIndex(value) {
        this.index = value;
    }
    getIndex() {
        return this.index;
    }
    getContainer() {
        return this.container;
    }
    getFrameContainer() {
        return this.frameContainer;
    }
    getAnimationsContainer() {
        return this.animationsContainer;
    }
    resetFlagsAndCounters() {
        this.virtualReelPosition = Utils.getRandomInt(0, scene.linkGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.canStop = false;
        this.stopped = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    resetCellsPositions() {
        this.linkCells.forEach((linkCell, index) => {
            linkCell.getContainer().y = this.linkCellsPosition[index].y;
        });
    }
    reIndexCells() {
        let linkCells = [];
        for (let i = 1; i < this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel; i++) {
            linkCells[i - 1] = this.linkCells[i];
            this.linkCells[i].setIndex(i - 1);
        }
        this.linkCells[0].setIndex(this.lastLinkCellIndex);
        linkCells[this.lastLinkCellIndex] = this.linkCells[0];
        this.linkCells = [];
        this.linkCells = linkCells;
    }
    get stepMs() { return this.spinAnimationDuration / this.spinSpeed; }
    configureSpinTween() {
        this.resetFlagsAndCounters();
    }
    //Chiamato dal gioco per far partire il giro del rullo
    spin(mainButtonBackground) {
        this.spinProgress.play();
        if (mainButtonBackground) {
            if (window.isButtonSpinning === false) {
                window.isButtonSpinning = true;
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground);
            }
        }
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }
    reset() {
        this.fixedLinkCell.getContainer().setVisible(false).setAlpha(1);
        this.fixedLinkCell.setMemo(0);
        this.fixedLinkCell.multValue = -1;
        this.container.setVisible(true);
        this.fixedLinkCell.getLinkSpineValueText().setVisible(false);
        this.fixedLinkCell.getLinkSpineWithValue().setVisible(false);
        this.fixedLinkCell.getLinkSpineWithText().setVisible(false).setAlpha(1);
    }
    updateMask(_x, _y) {
        return;
        const x = _x + (this.linkReelsPosition[this.getIndex()].x);
        const y = _y + (this.linkReelsPosition[this.getIndex()].y);
        const width = this.cellSize.width;
        const height = this.cellSize.height;
        if (this.lastMaskX === x && this.lastMaskY === y && this.lastMaskWidth === width && this.lastMaskHeight === height) {
            return;
        }
        // destroy the previous mask and create the new one
        if (this.linkReelMask) {
            this.linkReelMask.destroy();
        }
        this.container.clearMask(true);
        if (scene.linkGameArea.drawMask) {
            this.linkReelMask = scene.add.graphics({});
            this.linkReelMask.fillStyle(0xffffff, 0);
            this.linkReelMask.fillRect(x, y, width, height);
            this.container.setMask(new Phaser.Display.Masks.GeometryMask(scene, this.linkReelMask)); //SBAGLIATA
            this.lastMaskX = x;
            this.lastMaskY = y;
            this.lastMaskWidth = width;
            this.lastMaskHeight = height;
        }
    }
}
